/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Omit<Vacancy, \'id\'>, schemaOptions: { title: \'NewVacancy\', exclude: [ \'id\' ] })
 */
export interface NewVacancy { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    jobName: string;
    city: string;
    areaUnitBusiness?: string;
    employeeReplace?: string;
    ammount?: number;
    compensationScheme?: number;
    duration?: string;
    interviewProcess?: number;
    reason?: string;
    comments?: string;
    authorizationDate?: string;
    authorized?: boolean;
    justification?: string;
    candidate?: string;
    deliveryDate?: string;
    dateInitial?: string;
    code?: string;
    level?: string;
    dateCancellation?: string;
    dateDeclined?: string;
    dateSignature?: string;
    dateReactivated?: string;
    companyId?: string;
    requiredById?: number;
    authorizedById?: number;
    vacancyStatusId?: string;
    requisitionPersonalId?: string;
    jobPositionId?: string;
    requisitionTypeId?: string;
    contractTypeId?: string;
    substitutionTypeId?: string;
    placeTypeId?: string;
    authorizedSalaryId?: string;
    businessUnitId?: string;
}

